import Client from "./clients/rest";
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */

export default {
    logout(rt) {
        return Client.put("/auth/logout", {
            rt: rt
        });
    }
};

